import { VApp } from 'vuetify/lib/components/VApp';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,{attrs:{"id":"app"}},[_c('router-view'),_c('ex-alert'),_c('alert-link')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }